import { Navigate } from "react-router-dom";
import Navbar from "../components/Navbar/Navbar";
import { LoginService } from "../services";

export default function ProtectedPage({ showNavbar, children }) {
  const user = LoginService.getUser();
  if (!user) {
    console.log(user);
    return <Navigate to="/login" replace />;
  } else if (showNavbar === true)
    return (
      <div>
        <Navbar />
        {children}
      </div>
    );
  else {
    return children;
  }
}
